import { useTranslation } from 'react-i18next';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

import { LoginState } from '../contexts/LoginStateContext/LoginStateContext';
import { LoginStateProvider } from '../contexts/LoginStateContext/LoginStateProvider';
import { useLoginState } from '../contexts/LoginStateContext/useLoginState';
import { AuthBodySection } from '../components/AuthBodySection/AuthBodySection';
import { AuthPage } from '../components/AuthPage/AuthPage';
import { PasswordlessLoginForm } from '../components/PasswordlessLoginForm/PasswordlessLoginForm';
import { PasswordlessSuccess } from '../components/PasswordlessSuccess/PasswordlessSuccess';
import { PasswordLoginForm } from '../components/PasswordLoginForm/PasswordLoginForm';

export function Login() {
  return (
    <LoginStateProvider>
      <LoginWithContext />
    </LoginStateProvider>
  );
}

function LoginWithContext() {
  const { t } = useTranslation();
  const { loginState } = useLoginState();

  return (
    <AuthPage>
      {loginState === LoginState.passwordless ? (
        <AuthBodySection heading={t('auth:heading.passwordless')}>
          <PasswordlessLoginForm />
        </AuthBodySection>
      ) : loginState === LoginState.passwordlessSuccess ? (
        <AuthBodySection heading={t('auth:heading.passwordlessSuccess')}>
          <div className="w-min self-center rounded-full bg-procuros-grey p-4 text-slate-900">
            <EnvelopeIcon className="size-8" />
          </div>
          <PasswordlessSuccess
            confirmationText={t('auth:body.passwordlessSuccessConfirmation')}
            nextStepsText={t('auth:body.passwordlessSuccessNextSteps')}
          />
        </AuthBodySection>
      ) : (
        <AuthBodySection heading={t('auth:heading.password')}>
          <PasswordLoginForm />
        </AuthBodySection>
      )}
    </AuthPage>
  );
}
